(() => {
  const STORAGE_KEY = 'rechilero_recently_viewed';
  const MAX_ITEMS = 12;

  function getItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function setItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* localStorage lleno o bloqueado (modo privado) -- sin historial, la pagina sigue funcionando igual. */
    }
  }

  function readCurrentProduct() {
    const tag = document.querySelector('[data-rechilero-recently-viewed-current]');
    if (!tag) return null;
    try {
      const product = JSON.parse(tag.textContent);
      return product && product.id ? product : null;
    } catch (error) {
      return null;
    }
  }

  function recordCurrentProduct(product) {
    if (!product) return;
    const items = getItems().filter((item) => item.id !== product.id);
    items.unshift(product);
    setItems(items.slice(0, MAX_ITEMS));
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (char) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]
    ));
  }

  function renderRecentlyViewed(excludeId) {
    const section = document.querySelector('[data-rechilero-recently-viewed]');
    if (!section) return;
    const grid = section.querySelector('[data-rechilero-recently-viewed-grid]');
    if (!grid) return;

    const items = getItems().filter((item) => item.id !== excludeId);
    if (items.length === 0) return;

    grid.innerHTML = items
      .map((item) => `
        <a href="${escapeHtml(item.url)}" class="rechilero-card">
          <span class="rechilero-card__media">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="600" height="600" loading="lazy">` : ''}
          </span>
          <span class="rechilero-card__title">${escapeHtml(item.title)}</span>
          <span class="rechilero-card__price">${escapeHtml(item.price)}</span>
        </a>
      `)
      .join('');

    section.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const currentProduct = readCurrentProduct();
    recordCurrentProduct(currentProduct);
    renderRecentlyViewed(currentProduct ? currentProduct.id : null);
  });
})();
